module.exports = __webpack_public_path__ + "static/media/footer_facebook.17e45344.svg";